import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';

const ProjectOrg = (props: any) => {
  const projectTitle = props?.projectTitle;
  const projectDesc = props?.projectDesc;
  const projectData = props?.projectData;

  return (
    <section className="sv-project-organization">
      <h2 className="section-heading">{projectTitle}</h2>
      <div className="container">
        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(projectDesc),
          }}
        />
        {projectData?.Title || ''}
        <Image
          sizes="(max-width: 375px) 320px, (max-width: 576px) 576px, (max-width: 768px) 768px, (max-width: 992px) 992px, (max-width: 1280px) 1200px"
          src={projectData?.Background_Image?.data?.attributes?.url}
          alt={projectData?.Background_Image?.data?.attributes?.url}
          className="project-img img-fluid"
          width="1200"
          height="371"
        />
      </div>
    </section>
  );
};

export default ProjectOrg;
